import React, {useState} from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown} from "react-bootstrap";
import "./BuyingProperty.scss";
import $ from 'jquery/dist/jquery.min.js'
import BuyingPropertyDesktop from "../../../images/StaticPage/buying-property-img-d.jpg";
import BuyingPropertyTablet from "../../../images/StaticPage/buying-property-img-t.jpg";
import BuyingPropertyMobile from "../../../images/StaticPage/buying-property-img-m.jpg";
import ReactMarkdown from "react-markdown"
import GetURL from '@Components/common/site/get-url';
import { getSrc } from "gatsby-plugin-image"
const BuyingProperty = (props) => {

    const [stepblock, setStepblock] = useState(0);
    const NextStep = (event) => {
        setStepblock(event);
        // $('html, body').animate({
        //     scrollTop: $(".steps-wrapper .stepcount-row").offset().top-120
        //   }, 1500);    
    }
    return (
        <React.Fragment>
            <section className="buying-property steps-wrapper">
                <Container>
                    <Row>
                        <Col md={12}>
                        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                            <h2>{props.Title}</h2>
                            <p className="content-intro">
                                <ReactMarkdown source={props.Content} allowDangerousHtml />
                            </p>
                            </ScrollAnimation>
                        </Col>
                    </Row>
                    <Row className="stepcount-row">
                        <Col lg={12}>
                            <div className="stepcount">
                                <ul>
                                {props.Steps.map((step, index) => {
                                    return<>
                                    <li className={index === stepblock?"active-stepcount":""}>
                                        <a href="javascript:void(0)" onClick={()=>NextStep(index)}>
                                            <span className="stepcount-number">
                                                    {index+1}
                                            </span>
                                        </a>
                                    </li>                                    
                                    </>
                                })}
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row className="buying-property-content"> 
                    {props.Steps.map((step, index) => {
                        return<>
                        {index === stepblock && 
                            <>
                            {step.Image?.url_sharp &&
                            <Col lg={5}>
                            <ScrollAnimation animateOnce={true} animateIn="zoomIn">
                            <div className="img-hover-zoom buying-property-aside-img">    
                            {/* <picture>
                            <source media="(min-width:992px)" srcSet={step.Image?.url} />
                            <source media="(min-width:768px)" srcSet={step.Image?.url} />
                            <img src={step.Image?.url} alt={step.Image?.alternativeText} />
                            </picture> */}
                            <img src={getSrc(step.Image?.url_sharp)} alt={step.Image?.alternativeText} />
                            </div>
                            </ScrollAnimation>
                            </Col>
                            }
                            <Col lg={step.Image?.url_sharp ? 7 : 12} className={step.Image?.url_sharp ? "buying-property-text-content" : "buying-property-text-content no-left"}>
                            <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                                <h2 className="sub-head">{step.Title}</h2>
                                <ReactMarkdown source={step.Content} allowDangerousHtml />
                                {step.Cta_Url && step.Cta_Label ?
                                <GetURL label={step.Cta_Label} class="btn btn-outline" alias={step.Cta_Url?.URL} />
                                : props.Steps?.length === index+1 ? null 
                                : step.Cta_Label ?
                                <a href="javascript:void(0)" onClick={()=>NextStep(index+1)} className="btn btn-outline">{step.Cta_Label}</a>
                                : null
                                }
                            </ScrollAnimation>
                            </Col>
                            </>
                        }
                        </>
                    })}

                    </Row>    
                </Container>
            </section>
        </React.Fragment>
    )
}

export default BuyingProperty;